<template>
  <div style="margin-top: -60px">
    <v-container fluid class="secondary">
      <router-link :to="{ name: 'home' }">
        <img
          class="logo"
          :src="require('@/assets/pharmatLogo.jpg')"
          height="98"
          alt="logo"
        />
      </router-link>
    </v-container>
    <app-progress v-if="$store.state.loading"></app-progress>
    <v-container fluid class="primary">
      <h1 class="ml-16" style="font-size: 2.5em">
        <span id="header">Ba</span>
        <span id="header2">se </span>
        <span id="header3">de données</span>
      </h1>
    </v-container>
    <div class="mb-3">
      <a
        class="guide ml-3"
        href="https://public.euro-pharmat.com/pub_dm/commission_documents.aspx"
        >Documents Commission Technique</a
      >
    </div>
    <search-results v-if="$route.name != 'multiCriteres'" />
  </div>
</template>

<script>
import SearchResults from "@/components/SearchResults.vue";
import AppProgress from "@/components/AppProgress.vue";

export default {
  name: "AppHeader",
  components: {
    AppProgress,
    SearchResults,
  },
  // props: ["fournis"],
};
</script>
<style scoped>
.logo {
  position: absolute;
  left: 9%;
  width: 83px;
  bottom: 0;
}

.secondary {
  margin-top: 35px !important;
  display: block;
  position: relative;
  height: 40px;
}

.primary {
  height: 5em;
}

#header {
  color: white;
  border-bottom: 4px solid;
  font-family: "Andes", arial;
  font-weight: 500s;
  padding: 0 0 1px 0;
}
#header2 {
  color: white;
  font-weight: 500;
  font-family: "Andes", arial;
}
#header3 {
  color: white;
  font-weight: 300;
  font-family: "Andes", arial;
}
.guide {
  color: #38af53;
  font-size: 13px;
  text-decoration: none;
}

.footer {
  color: white;
  padding: 0 25px;
}
</style>
